import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthenticationService } from './services/authentication/authentication.service';
import { NgxsModule } from '@ngxs/store';
import { FilterState } from './state/filter-state/filter.state';



@NgModule({ declarations: [], imports: [CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        NgxsModule.forRoot([FilterState])], providers: [
        AuthenticationService,
    ] })
export class CoreModule { }
